import { html, render } from 'lit';
import { TrackerManager } from './lib/tracker-manager';
import { spread } from './helpers/spread'
import { loadFingerPrintManagerModule, loadIdentifyServiceModule, loadTrackEnqueueModule } from './lib/utils';

const utils = {
  channelMap: {
    editore: {
      portal: 'radio',

      'rai.tv': 'rai.tv',
      raitv: 'rai.tv',
      'rai tv': 'rai.tv',

      'rai.it': 'rai.it',
      raiit: 'rai.it',
      'rai it': 'rai.it',
      'logoeditoreminisito_rai.it': 'rai.it',

      raiuno: 'rai 1',
      'rai uno': 'rai 1',
      'rai 1': 'rai 1',
      rai1: 'rai 1',
      'rai.it - rai uno': 'rai 1',

      raidue: 'rai 2',
      'rai due': 'rai 2',
      'rai 2': 'rai 2',
      rai2: 'rai 2',
      'rai.it - rai due': 'rai 2',

      raitre: 'rai 3',
      'rai tre': 'rai 3',
      'rai 3': 'rai 3',
      rai3: 'rai 3',
      'rai.it - rai tre': 'rai 3',

      raiquattro: 'rai 4',
      'rai quattro': 'rai 4',
      'rai 4': 'rai 4',
      rai4: 'rai 4',
      'rai.it - rai quattro': 'rai 4',

      extra: 'rai 5',
      raiextra: 'rai 5',
      'rai extra': 'rai 5',
      raicinque: 'rai 5',
      'rai cinque': 'rai 5',
      'rai 5': 'rai 5',
      rai5: 'rai 5',
      'rai.tv - rai 5': 'rai 5',
      'rai.it - rai 5': 'rai 5',

      raisport: 'raisport',
      'rai sport': 'raisport',

      raisport1: 'raisport 1',
      'raisport 1': 'raisport 1',
      'rai sport 1': 'raisport 1',

      raisport2: 'raisport 2',
      'raisport 2': 'raisport 2',
      'rai sport 2': 'raisport 2',

      raiedu2: 'rai storia',
      raistoria: 'rai storia',
      'rai storia': 'rai storia',

      raimovie: 'rai movie',
      'rai movie': 'rai movie',
      movie: 'rai movie',
      'movie_logodirete2.png': 'rai movie',

      premium: 'rai premium',
      raipremium: 'rai premium',
      'rai premium': 'rai premium',
      'rai.it - rai premium': 'rai premium',

      raigulp: 'rai gulp',
      'rai gulp': 'rai gulp',
      rai_gulp: 'rai gulp',

      yoyo: 'rai yoyo',
      raiyoyo: 'rai yoyo',
      'rai yoyo': 'rai yoyo',
      'logo editore rai yoyo': 'rai yoyo',
      'logo editor rai yoyo': 'rai yoyo',

      raieducational: 'rai scuola',
      raiscuola: 'rai scuola',
      'rai scuola': 'rai scuola',

      'rai news': 'rai news',
      rainews: 'rai news',
      news: 'rai news',

      'rai news 24': 'rai news 24',
      'rainews 24': 'rai news 24',
      'news 24': 'rai news 24',
      'rai news24': 'rai news 24',
      rainews24: 'rai news 24',
      news24: 'rai news 24',

      cciss: 'cciss',
      isoradio: 'isoradio',
      logoisoradio_minisiti: 'isoradio',

      radiouno: 'radio 1',
      'radio uno': 'radio 1',
      'radio 1': 'radio 1',
      radio1: 'radio 1',
      logo_rete_radio1: 'radio 1',

      radiodue: 'radio 2',
      'radio due': 'radio 2',
      'radio 2': 'radio 2',
      radio2: 'radio 2',

      radiotre: 'radio 3',
      'radio tre': 'radio 3',
      'radio 3': 'radio 3',
      radio3: 'radio 3',

      'filodiffusione quattro': 'fd4',
      'filodiffusione 4': 'fd4',
      filodiffusionequattro: 'fd4',
      filodiffusione4: 'fd4',
      fd4: 'fd4',
      'fd 4': 'fd4',

      'filodiffusione cinque': 'fd5',
      'filodiffusione 5': 'fd5',
      filodiffusionecinque: 'fd5',
      filodiffusione5: 'fd5',
      fd5: 'fd5',
      'fd 5': 'fd5',

      webradio6: 'webradio 6',
      'web radio6': 'webradio 6',
      'rai web radio6': 'webradio 6',
      'rai webradio6': 'webradio 6',
      wr6: 'webradio 6',
      logoeditoreminisito_webradio6: 'webradio 6',

      webradio7: 'webradio 7',
      'web radio7': 'webradio 7',
      webradio7_ridotto: 'webradio 7',
      'rai web radio7': 'webradio 7',
      'rai webradio7': 'webradio 7',
      wr7: 'webradio 7',
      logoeditoreminisito_webradio7: 'webradio 7',

      webradio8: 'webradio 8',
      'web radio8': 'webradio 8',
      'rai web radio8': 'webradio 8',
      'rai webradio8': 'webradio 8',
      wr8: 'webradio 8',
      logoeditoreminisito_webradio8: 'webradio 8',

      'rai grparlamento': 'grparlamento',
      'rai gr parlamento': 'grparlamento',
      'gr parlamento': 'grparlamento',

      raitrade: 'raitrade',
      televideo: 'televideo',
      'nuovi talenti': 'nuovi talenti',

      vaticano: 'rai vaticano',
      raivaticano: 'rai vaticano',
      'rai vaticano': 'rai vaticano',
      'vaticano logo rete': 'rai vaticano',

      junior: 'junior',
      raijunior: 'junior',
      'rai junior': 'junior',

      'tg 1': 'tg 1',
      tg1: 'tg 1',

      'tg 2': 'tg 2',
      tg2: 'tg 2',

      'tg 3': 'tg 3',
      tg3: 'tg 3',

      tgr: 'tgr',

      'rai cinema': 'rai cinema',
      raicinema: 'rai cinema',
      cinema: 'rai cinema',
      cinema_logo: 'rai cinema',
    },
    canale: {
      portal: 'radio',

      'rai.tv': 'rai.tv',
      raitv: 'rai.tv',
      'rai tv': 'rai.tv',

      'rai.it': 'rai.it',
      raiit: 'rai.it',
      'rai it': 'rai.it',
      'logoeditoreminisito_rai.it': 'rai.it',

      raiuno: 'rai 1',
      'rai uno': 'rai 1',
      'rai 1': 'rai 1',
      rai1: 'rai 1',
      'rai.it - rai uno': 'rai 1',

      raidue: 'rai 2',
      'rai due': 'rai 2',
      'rai 2': 'rai 2',
      rai2: 'rai 2',
      'rai.it - rai due': 'rai 2',

      raitre: 'rai 3',
      'rai tre': 'rai 3',
      'rai 3': 'rai 3',
      rai3: 'rai 3',
      'rai.it - rai tre': 'rai 3',

      raiquattro: 'rai 4',
      'rai quattro': 'rai 4',
      'rai 4': 'rai 4',
      rai4: 'rai 4',
      'rai.it - rai quattro': 'rai 4',

      extra: 'rai 5',
      raiextra: 'rai 5',
      'rai extra': 'rai 5',
      raicinque: 'rai 5',
      'rai cinque': 'rai 5',
      'rai 5': 'rai 5',
      rai5: 'rai 5',
      'rai.tv - rai 5': 'rai 5',
      'rai.it - rai 5': 'rai 5',

      raisport: 'raisport',
      'rai sport': 'raisport',

      raisport1: 'raisport 1',
      'raisport 1': 'raisport 1',
      'rai sport 1': 'raisport 1',

      raisport2: 'raisport 2',
      'raisport 2': 'raisport 2',
      'rai sport 2': 'raisport 2',

      raiedu2: 'rai storia',
      raistoria: 'rai storia',
      'rai storia': 'rai storia',

      raimovie: 'rai movie',
      'rai movie': 'rai movie',
      movie: 'rai movie',
      'movie_logodirete2.png': 'rai movie',

      premium: 'rai premium',
      raipremium: 'rai premium',
      'rai premium': 'rai premium',
      'rai.it - rai premium': 'rai premium',

      raigulp: 'rai gulp',
      'rai gulp': 'rai gulp',
      rai_gulp: 'rai gulp',

      yoyo: 'rai yoyo',
      raiyoyo: 'rai yoyo',
      'rai yoyo': 'rai yoyo',
      'logo editore rai yoyo': 'rai yoyo',
      'logo editor rai yoyo': 'rai yoyo',

      raieducational: 'rai scuola',
      raiscuola: 'rai scuola',
      'rai scuola': 'rai scuola',

      'rai news': 'rai news',
      rainews: 'rai news',
      news: 'rai news',

      'rai news 24': 'rai news 24',
      'rainews 24': 'rai news 24',
      'news 24': 'rai news 24',
      'rai news24': 'rai news 24',
      rainews24: 'rai news 24',
      news24: 'rai news 24',

      cciss: 'cciss',
      isoradio: 'isoradio',
      logoisoradio_minisiti: 'isoradio',

      radiouno: 'radio 1',
      'radio uno': 'radio 1',
      'radio 1': 'radio 1',
      radio1: 'radio 1',
      logo_rete_radio1: 'radio 1',

      radiodue: 'radio 2',
      'radio due': 'radio 2',
      'radio 2': 'radio 2',
      radio2: 'radio 2',

      radiotre: 'radio 3',
      'radio tre': 'radio 3',
      'radio 3': 'radio 3',
      radio3: 'radio 3',

      'filodiffusione quattro': 'fd4',
      'filodiffusione 4': 'fd4',
      filodiffusionequattro: 'fd4',
      filodiffusione4: 'fd4',
      fd4: 'fd4',
      'fd 4': 'fd4',

      'filodiffusione cinque': 'fd5',
      'filodiffusione 5': 'fd5',
      filodiffusionecinque: 'fd5',
      filodiffusione5: 'fd5',
      fd5: 'fd5',
      'fd 5': 'fd5',

      webradio6: 'webradio 6',
      'web radio6': 'webradio 6',
      'rai web radio6': 'webradio 6',
      'rai webradio6': 'webradio 6',
      wr6: 'webradio 6',
      logoeditoreminisito_webradio6: 'webradio 6',

      webradio7: 'webradio 7',
      'web radio7': 'webradio 7',
      webradio7_ridotto: 'webradio 7',
      'rai web radio7': 'webradio 7',
      'rai webradio7': 'webradio 7',
      wr7: 'webradio 7',
      logoeditoreminisito_webradio7: 'webradio 7',

      webradio8: 'webradio 8',
      'web radio8': 'webradio 8',
      'rai web radio8': 'webradio 8',
      'rai webradio8': 'webradio 8',
      wr8: 'webradio 8',
      logoeditoreminisito_webradio8: 'webradio 8',

      'rai grparlamento': 'grparlamento',
      'rai gr parlamento': 'grparlamento',
      'gr parlamento': 'grparlamento',

      raitrade: 'raitrade',
      televideo: 'televideo',
      'nuovi talenti': 'nuovi talenti',

      vaticano: 'rai vaticano',
      raivaticano: 'rai vaticano',
      'rai vaticano': 'rai vaticano',
      'vaticano logo rete': 'rai vaticano',

      junior: 'junior',
      raijunior: 'junior',
      'rai junior': 'junior',

      'tg 1': 'tg 1',
      tg1: 'tg 1',

      'tg 2': 'tg 2',
      tg2: 'tg 2',

      'tg 3': 'tg 3',
      tg3: 'tg 3',

      tgr: 'tgr',

      'rai cinema': 'rai cinema',
      raicinema: 'rai cinema',
      cinema: 'rai cinema',
      cinema_logo: 'rai cinema',
    },
  },
  getMeta(name: string, toLower?: boolean) {
    const metas = document.getElementsByTagName("meta");
    for (const meta of metas) {
      if (meta.getAttribute("property") === name || meta.getAttribute("name") === name) {
        const res = meta.getAttribute("content") || meta.getAttribute("value");
        if (!res) {
          return ""
        }
        return toLower ? res.toLowerCase() : res;
      }
    }
    return ""
  },
  normalize(prop: string, submap: unknown) {
    if (typeof submap !== "string") {
      return prop
    }
    const map = this.channelMap[submap as keyof typeof this.channelMap];
    if (typeof prop !== "string") {
      return ""
    }
    if (typeof map !== "object") {
      return prop
    }
    let res = prop;
    if (map[prop as keyof typeof map]) {
      res = map[prop as keyof typeof map];
    } else if (map[prop.toLowerCase() as keyof typeof map]) {
      res = map[prop.toLowerCase() as keyof typeof map];
    }
    return res;
  }
};

function getTrackInfo() {
  const trackInfo = {
    id: utils.getMeta("uniquename") && !utils.getMeta("uniquename").includes("@uniquename")
      ? utils.getMeta("uniquename", false)
      : document.location.pathname.replace(/[^\w\s/-]/gi, "").replace(/\|/gi, "").replace(/\//gi, "__"),
    domain: utils.getMeta("dominio"),
    typology: utils.getMeta("tematica"),
    program_title: utils.getMeta("nomeProgramma"),
    content: utils.getMeta("contenuto"),
    section: utils.getMeta("sezione"),
    sub_section: utils.getMeta("sottosezione"),
    genres: [utils.getMeta("genere")],
    sub_genres: [utils.getMeta("sottogenere")],
    year: utils.getMeta("anno"),
    edition: utils.getMeta("edizione"),
    channel: utils.normalize(utils.getMeta("canale"), "canale"),
    creation_date: utils.getMeta("data"),
    page_type: utils.getMeta("pageType"),
    season: utils.getMeta("stagione"),
    episode_title: utils.getMeta("titolo_episodio"),
    episode_number: utils.getMeta("numero_episodio"),
    editor: utils.normalize(utils.getMeta("editore"), "editore"),
    nodmp: false
  };

 return trackInfo;
}

declare module './lib/tracker-manager' {
  interface TrackerManager {
    getTrackInfo(): ReturnType<typeof getTrackInfo>;
  }
}

TrackerManager.prototype.getTrackInfo = getTrackInfo;

async function initializeTracker() {
  await loadTrackEnqueueModule();
  await loadIdentifyServiceModule();
  await loadFingerPrintManagerModule();

  customElements.define("rai-tracker-retrocomp", TrackerManager);

  const attributes = { pageInfo: JSON.stringify(getTrackInfo()), ...(raiWebComponents.attributes?.['rai-tracker-retrocomp'] ?? {}) };
  const div = document.querySelector<HTMLDivElement>("#tracker") ?? document.createElement("div");
  const exists = document.querySelector("rai-tracker-retrocomp");
  if (!div.isConnected && !exists) {
    div.setAttribute("id", "tracker");
    document.body.appendChild(div);
  }
  if (!exists) {
    customElements.whenDefined("rai-tracker-retrocomp").then(() => {
      render(html`<rai-tracker-retrocomp ...=${spread(attributes)}></rai-tracker-retrocomp>`, div);
    });
  }
}

initializeTracker();